import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import {
    INVENTORY_SEARCH_CLICKED,
    INVENTORY_STOCKING_MODAL_FORM_SUBMITTED,
    INVENTORY_STOCKING_MODAL_TOGGLE_CLICKED,
} from "./actions"
import { FETCH_INVENTORY_LOG_OF_CHANGES_SUCCESS } from "../../../api/actions"
import type { InventoryTransactionLog } from "./components/LogOfChangesTable"

export type InventoryState = {
    stockingModalInventoryItemId: Maybe<string>
    searchKey: Maybe<string>
    logsOfChanges: InventoryTransactionLog[]
}

export const createDefaultInventoryState = () => ({
    stockingModalInventoryItemId: null,
    searchKey: null,
    logsOfChanges: [],
})
export const inventoryReducer = (state: Maybe<InventoryState> = undefined, action: Record<string, any>) => {
    if (!state) {
        return createDefaultInventoryState()
    }

    switch (action.type) {
        case INVENTORY_SEARCH_CLICKED: {
            return { ...state, searchKey: action.payload.pattern }
        }

        case INVENTORY_STOCKING_MODAL_TOGGLE_CLICKED: {
            return { ...state, stockingModalInventoryItemId: action.payload.inventoryItemId }
        }

        case FETCH_INVENTORY_LOG_OF_CHANGES_SUCCESS: {
            return { ...state, logsOfChanges: action.payload.data }
        }

        case INVENTORY_STOCKING_MODAL_FORM_SUBMITTED: {
            return { ...state, stockingModalInventoryItemId: null }
        }

        default:
            return state
    }
}
